module.exports = __webpack_public_path__ + "static/2cents-f9a610dffc5b4890584e317739ac55d9.png";